import { debounce } from 'throttle-debounce';
import { datadogRum } from '@datadog/browser-rum';
import { INITIAL_STATE } from 'Configs/config';
import CombinedStorage from 'Utils/storage/CombinedStorage';
const LOCAL_STORAGE_KEY = 'rirekisho_multistep_values';
const DEBOUNCE_DELAY = 1000;
export default class LocalStorageManager {
    storeKey;
    static _instance;
    static instance() {
        return (this._instance ||
            (this._instance = new LocalStorageManager(LOCAL_STORAGE_KEY, DEBOUNCE_DELAY)));
    }
    saveValues;
    storage;
    values;
    valuesPromise;
    constructor(storeKey, debounceDelay) {
        this.storeKey = storeKey;
        this.storage = CombinedStorage.instance();
        this.valuesPromise = this.initValues();
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.saveValues = debounce(debounceDelay, this.rawSaveValues);
    }
    clearValues() {
        localStorage.removeItem(this.storeKey);
    }
    getValues() {
        return this.values;
    }
    async ready() {
        return this.valuesPromise;
    }
    async initValues() {
        try {
            const values = await this.storage.getItem(this.storeKey);
            if (!values) {
                // saved value is empty
                this.values = INITIAL_STATE;
                this.storage.setItem(this.storeKey, this.values);
            }
            else {
                this.values = values;
            }
        }
        catch (e) {
            datadogRum.addError(e);
            // Failed to decode values due to no value stored or decryption error.
            // Reset state and values to default
            this.values = INITIAL_STATE;
            this.storage.setItem(this.storeKey, this.values);
        }
    }
    rawSaveValues(v) {
        this.values = v;
        this.storage.setItem(this.storeKey, v);
    }
}
